import { atom } from 'nanostores';

export const showMySupplementsModal = atom<boolean>(false);
export const subscriptionSelectorModalData = atom<
  | {
      containerId: number;
      containerName: string;
      occasionId: number;
      occasionGroupId: number;
    }
  | undefined
>();
export const enableSkipSubscription = atom<
  | {
      customerId: number;
      orderId: number;
      containerId: number;
      containerName: string;
    }
  | undefined
>();
